<template>
    <div id="main-modal">
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('motivo-reprovacao') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button 
                    class="delete-btn" 
                    type="button" 
                    @click="fecharModal()"
                    :disabled="isLoadingEdit || isLoading || isSaving"
                >
                    {{ $t(cantEdit ? 'fechar' : 'cancelar') }}
                </button>
                <button 
                    v-if="!cantEdit"
                    class="save-btn" 
                    type="button" 
                    @click="saveValida" 
                    :disabled="isLoadingEdit || isLoading || isSaving"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <br />

        <div class="form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <vss-select
                        :id="generateId(1)"
                        ref="motivoSelect"
                        title="motivo"
                        searchable
                        :options="motivoSelect"
                        v-model="motivoSelected"
                        :required="true"
                        :invalid="isNull(motivoSelected)"
                        :loading="motivoLoading"
                        @search="loadMotivo"
                        @onBlurFunction="sendIsChanged('motivo')"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(2)"
                        ref="descricaoInput"
                        v-model="motivoregistro.descricao"
                        :maxlength="500"
                        title="descricao"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(motivoregistro.descricao)"
                        :required="true"
                        :disabled="cantEdit"
                    />
                </div>
                <div 
                    class="column is-6"
                    v-if="permissaoFields.contato>0"
                >
                    <v-input
                        :id="generateId(5)"
                        ref="contatoInput"
                        v-model="motivoregistro.contato"
                        :maxlength="255"
                        title="contato"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        :required="permissaoFields.contato==2"
                        :invalid="permissaoFields.contato==2
                            &&isNull(motivoregistro.contato)"
                        :disabled="cantEdit"
                    />
                </div>
                <div 
                    class="column is-12" 
                    v-if="permissaoFields.observacao>0
                ">
                    <v-textarea
                        ref="observacaoTextarea"
                        :id="generateId(7)" 
                        v-model="motivoregistro.observacao"
                        title="observacao"
                        placeholder="placeholder-preencha"
                        :required="permissaoFields.observacao==2"
                        :invalid="permissaoFields.observacao==2
                            &&isNull(motivoregistro.observacao)"
                        :rows="6"
                        :maxRows="6"
                        :disableTransform="true"
                        :maxlength="1000"
                        :disabled="cantEdit"
                    />
                </div>
                <div 
                    class="column is-12"
                    v-show="motivoSelected!=null"
                >
                    <multiple-img-picker
                        v-if="
                            (
                                cantEdit && 
                                (motivoregistro.motivoregistrofoto 
                                && motivoregistro.motivoregistrofoto.length != 0)
                            ) 
                            || !cantEdit
                        "
                        :id="generateId(10)"
                        ref="imagePicker"
                        :value="motivoregistro.motivoregistrofoto || null"
                        title="fotos"
                        :subtitle="` (Quantidade Mínima ${permissaoFields.qtdeminimafoto})`"
                        :msg="permissaoFields.qtdeminimafoto>0?'msg-campo-obrigatorio':null"
                        :qtdeminimafoto="permissaoFields.qtdeminimafoto"
                        @uploadedFiles="obterFotos"
                        :disabled="cantEdit"
                        :showOldPhotos="cantEdit"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MotivoRegistroService from "@/services/agro/MotivoRegistroService";
import MotivoService from "@/services/agro/MotivoService";
import MotivoRegitroValidation from "@/services/validations/agro/MotivoRegitroValidation";
import Message from "@/models/Message";
import MultipleImgPicker from "@/components/shared/form/MultipleImgPicker.vue";

export default {
    components: {
        MultipleImgPicker,
    },
    props: {
        id: {
            type: Number,
            default: 0
        },
        idmotivoregistro: {
            type: Number,
            default: 0
        },
        descricao: {
            type: String,
            default: ""
        },
        origem: null,
    },
    data() {
        return {
            showForm: true,
            service: new MotivoRegistroService(this.$http, this.$router),
            motivoService: new MotivoService(this.$http, this.$router),
            validation: new MotivoRegitroValidation(this.msgs),
            isLoading: false,
            isSaving: false,
            //para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
            msgs: [],
            motivoregistro: {
                uuid: null,
                idmotivo: null,
                idexterno: this.id,
                descricao: null,
                contato: null,
                observacao: null,
                replicapda: null,
                latitude: null,
                longitude: null,
                lastfix: null,
                tipogps: null,
                motivoregistrofoto: [],
                origem: this.origem
            },
            motivoSelect: [],
            motivoSelected: null,
            motivoLoading: true,

            permissaoFields: {
                contato: 0,
                observacao: 0,
                qtdeminimafoto: 0,
            },
            permissaoFieldsClean: {},
            cantEdit: false,
            
        };
    },
    created() {
        this.$emit("isChangedModal", false);
        this.permissaoFieldsClean = Object.assign({}, this.permissaoFields);
        if(this.idmotivoregistro > 0) {
            this.cantEdit = true;
            this.getById()
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-motivo-" + numberId;
        },
        // Emite ao componente pai se houve alteração em um campo select
        sendIsChanged(label=null) {
            if(this.cantEdit) return;
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);

            if(label=='motivo') {
                this.isLoading = true;
                this.permissaoFields = Object.assign({}, this.permissaoFieldsClean);
                if(this.motivoSelected!=null){
                    setTimeout(() => {
                        this.loadMotivoPermissao();
                    }, 300);
                }else{
                    this.isLoading = false;
                }
            }
        },
        fecharModal() {
            this.$emit("fecharModal", true);
        },
        loadMotivo(termo = null) {
            if(this.cantEdit) return;
            this.motivoLoading = true;

            let params = [  // Adicionar filtro complementar
                this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                'origem',
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.origem,
            ];

            this.motivoService
                .findAllCombo(params)
                .then(body => {
                    return body.content.map(m => {
                        return {
                            id: m.id,
                            label: m.descricao,
                            cor: m.cor,
                            icone: m.icone.toLowerCase(),
                        };
                    });
                })
                .then(r => {
                    this.motivoSelect = Object.assign(r);
                    if(this.motivoSelect.length==1){
                        this.motivoSelected = this.motivoSelect[0];
                        this.sendIsChanged('motivo');
                    }else if(this.motivoSelect.length == 0) {
                        this.promptSemMotivo();
                    }
                })
                .catch(e => {
                    this.$root.msgs.push(new Message("error", "msg-erro-load"));
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally(_ => {
                    this.motivoLoading = false;
                });
        },
        promptSemMotivo() {
            let msg = this.$t('info-sem-motivo-reprovacao-n', { n: this.descricao });
            this.$root.confirm({
                message: msg,
                onConfirm: _ => this.$emit("redirectMotivoReprovacao", true),
                onCancel: _ => this.saveAutomatically(),
            });
        },
        saveAutomatically() {
            // caso não tenha motivo a ação deve ocorrer automaticamente
            this.$emit("save", 0);
            this.fecharModal();
        },
        loadMotivoPermissao() {
            this.motivoLoading = true;
            this.motivoService
                .find(this.cantEdit ? this.motivoregistro.idmotivo : this.motivoSelected.id)
                .then(data => {
                    if(data.content){
                        if(this.cantEdit) {
                            this.motivoSelected = {
                                id: data.content.id,
                                label: data.content.descricao,
                                cor: data.content.cor,
                                icone: data.content.icone.toLowerCase(),
                            }
                        }

                        this.permissaoFields.contato = +data.content.habilitaobrigacontato;
                        this.permissaoFields.observacao = +data.content.habilitaobrigaobservacao;
                        this.permissaoFields.qtdeminimafoto = +data.content.qtdeminimafoto;
                    }else{
                        this.permissaoFields = Object.assign({}, this.permissaoFieldsClean);
                        this.$root.msgs.push(new Message("error", "msg-erro-load"));
                    }
                })
                .catch(e => {
                    this.$root.msgs.push(new Message("error", "msg-erro-load"));
                })
                .finally(_ => {
                    this.motivoLoading = false;
                    this.isLoading = false;
                });
        },
        obterFotos(fotos) {
            let temp_fotos = [];
            fotos.forEach((foto, i) => {
                temp_fotos[i] = {
                    nome: foto.fileName,
                    caminho: foto.url.replace(/^data:(.*,)?/, ''),
                    documentopda: {
                        nome_documento: foto.fileName,
                        url_documento: '',
                    },
                };
            });
            this.motivoregistro.motivoregistrofoto = temp_fotos;
        },
        getById() {
            this.isLoading = true;

            this.service
                .find(this.idmotivoregistro)
                .then(data => {
                    if(data.content) {
                        this.motivoregistro = data.content;
                    }
                })
                .catch(e => {
                    this.$root.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(_ => { 
                    this.isLoading = false; 
                    this.loadMotivoPermissao();
                })
        },
        successPosition(position){
            this.motivoregistro.latitude = (position.coords.latitude)?position.coords.latitude:0;
            this.motivoregistro.longitude = (position.coords.longitude)?position.coords.longitude:0;
            this.motivoregistro.lastfix = (position.timestamp)?position.timestamp:null;
            this.motivoregistro.tipogps = (position.coords.latitude)?1:0;
            console.info(position);
            this.save();
        },
        errorPosition(e){
            console.error('Geolocation error!', e);
            this.save();
        },
        saveValida() {
            // pega alocalização através do navegador caso esteja liberado
            if (navigator.geolocation) {
                console.log('Geolocation is supported by this browser');
                navigator.geolocation.getCurrentPosition(this.successPosition, this.errorPosition);
            } else {
                console.log('Geolocation is not supported by this browser');
                this.save();
            }
        },
        save() {
            this.isLoading = true;
            
            setTimeout(() => {
                let motivoregistroTemp = Object.assign({}, this.motivoregistro);
                // monta dados complementares
                motivoregistroTemp.idmotivo = 
                    this.motivoSelected!=null ? this.motivoSelected.id : null;

                if(this.validation.validate(motivoregistroTemp, this.permissaoFields, this.$refs)
                ){
                    motivoregistroTemp = this.mapTosave(motivoregistroTemp);

                    this.isSaving = true;
                    this.service.save(motivoregistroTemp)
                        .then(res => {
                            if (res.message == null) {
                                let msg = this.$t('msg-save-sucesso-n', { n: this.$t('motivo') });
                                this.$root.msgs.push(new Message('success', msg, true, false));
        
                                this.$emit("isChanged", false);
                                this.$emit("save", res.content.id);
                                this.fecharModal();
                            } else {
                                if (this.$t(res.message)) {
                                    this.$root.msgs.push(new Message('alert', res.message, true));
                                } else {
                                    this.$root.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                                }
                            }
                        })
                        .catch((e) => {
                            this.$root.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        })
                        .finally(() => {
                            this.isSaving = false;
                            this.isLoading = false;
                        });
                } else {
                    this.$root.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                    this.isLoading = false;
                }
            }, 300);
        },
    },
};
</script>

<style lang="scss" scoped>
#main-modal {
    padding: 20px 20px;
}
</style>